import { FieldValues } from 'react-hook-form';

export const formatExplorerOverallFilterData = ({ values }: { values: FieldValues }) =>
  Object.keys(values).reduce((prev, curr) => {
    let modifiedData = {};
    if (values[curr]) {
      const occupationData =
        values['occupation_ids'] &&
        Object.keys(values['occupation_ids']).length &&
        Object.keys(values['occupation_ids']).reduce((acc, id) => {
          if (values['domain_interest']?.includes(id)) acc[id] = values['occupation_ids'][id];
          return acc;
        }, {} as Record<string, string[]>);
      // Only the `occupation_ids` iteration may touch `occupation_ids`; every other key emits
      // nothing here so it can't clobber the value (previously it wrote `undefined`, which made
      // survival order-dependent). A flat string[] (e.g. from a saved-research email link) is
      // passed through as-is; the object-map form `{ [domainId]: string[] }` is flattened.
      const occupationIds =
        curr !== 'occupation_ids'
          ? {}
          : Array.isArray(values['occupation_ids'])
          ? { occupation_ids: (values['occupation_ids'] as string[]).map(String).filter(Boolean) }
          : occupationData &&
            Object.keys(occupationData).length &&
            Object.values(occupationData).flat().filter(Boolean).length
          ? {
              occupation_ids: Object.values(occupationData).flat().filter(Boolean) as string[],
            }
          : { occupation_ids: undefined };
      const common = { [curr]: singleMode.includes(curr) ? values[curr][0] : values[curr] };
      const formattedData = {
        ...common,
        ...(values['contract_type']?.length
          ? {
              contract_type: values['contract_type'],
            }
          : { contract_type: undefined }),
        ...(values['domain_interest']?.length
          ? {
              domain_interest: values['domain_interest'],
            }
          : { domain_interest: undefined }),
        ...(curr === 'seasonal_job_position' &&
          values['seasonal_job_position']?.length &&
          (values['seasonal_job_position'].includes('is_abroad_job')
            ? { is_abroad_job: true, seasonal_job_position: undefined }
            : { seasonal_job_position: JSON.parse(values['seasonal_job_position'][0]), is_abroad_job: undefined })),
        ...(curr === 'salary_rating' ? { salary_rating: values['salary_rating'].map((v: string | number) => +v) } : {}),
        ...(curr === 'career_rating' ? { career_rating: values['career_rating'].map((v: string | number) => +v) } : {}),
        ...(curr === 'max_salary' && values['max_salary']
          ? { max_salary: values['max_salary'] === 5000 ? 'infinite' : values['max_salary'].toString() }
          : { max_salary: undefined }),
        ...(values['job_type']?.length > 0
          ? {
              job_type: values['job_type'],
            }
          : {
              job_type: undefined,
            }),
        ...(curr === 'required_experience' && values[curr]?.length
          ? { required_experience: typeof values[curr] === 'string' ? values[curr] : values[curr][0] }
          : {}),
        ...(curr === 'user_location_radius' && values['user_location_radius']?.length
          ? { user_location_radius: +values['user_location_radius'][0] }
          : { user_location_radius: undefined }),
        ...occupationIds,
      };
      // modifiedData = omitBy(formattedData, (value) => value === undefined || value === null || value === '');
      modifiedData = { ...formattedData };
    }
    return {
      ...prev,
      ...modifiedData,
    };
  }, {});
export const singleMode = [
  'user_location_radius',
  'seasonal_job_position',
  'required_experience',
  'salary_rating',
  'career_rating',
];
export const multiMode = ['job_type', 'shifts', 'domain_interest', 'occupation_ids'];
export const userLocation = ['user_location_lat', 'user_location_lon'];
export const range = ['salary_range'];
export const applyMoreFilterAttrs = [
  ...singleMode,
  ...multiMode,
  ...userLocation,
  ...range,
  ...['address', 'max_salary', 'min_salary', 'benefits', 'contract_type', 'is_abroad_job'],
];
